"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _DD7MF4PQcjs = require('../__chunks/DD7MF4PQ.cjs');
require('../__chunks/XRATBFDX.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/form/form-group-label.tsx
var TagName = "div";
var useFormGroupLabel = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useFormGroupLabel2({ store, ...props }) {
    props = _DD7MF4PQcjs.useGroupLabel.call(void 0, props);
    return props;
  }
);
var FormGroupLabel = _PTOCUU2Dcjs.forwardRef.call(void 0, function FormGroupLabel2(props) {
  const htmlProps = useFormGroupLabel(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.FormGroupLabel = FormGroupLabel; exports.useFormGroupLabel = useFormGroupLabel;
